import { z } from 'zod';
export const HexColorSchema = z.string().regex(/^#[0-9A-Fa-f]{6}$/);
/**
 * A CSS `oklch()` color: `oklch(L C H)`, with an optional `/ alpha`. Lightness and
 * alpha take a number or a percentage, hue a number optionally suffixed `deg`.
 *
 * `@eigtech/config-tailwind/theme.css` is authored in oklch, so UI theme colors are
 * accepted in it - unlike email, where clients only understand hex.
 */
export const OklchColorSchema = z
    .string()
    .regex(/^oklch\(\s*\d+(?:\.\d+)?%?\s+\d+(?:\.\d+)?%?\s+\d+(?:\.\d+)?(?:deg)?\s*(?:\/\s*\d+(?:\.\d+)?%?\s*)?\)$/);
/** A color in either notation the UI accepts. */
export const ThemeColorSchema = z.union([HexColorSchema, OklchColorSchema]);
